// Client-side interactivity: mobile nav toggle + live link search/filter.
// Kept framework-free so the built output is plain JS.

function initMobileNav() {
  const toggle = document.querySelector(".navbar__toggle");
  const menu = document.querySelector(".navbar__menu");
  if (!toggle || !menu) return;

  toggle.addEventListener("click", () => {
    const open = menu.classList.toggle("is-open");
    toggle.setAttribute("aria-expanded", String(open));
  });
}

function initSearch() {
  const input = document.querySelector(".searchbar__input");
  if (!input) return;

  const empty = document.querySelector(".searchbar__empty");
  const items = Array.from(document.querySelectorAll("[data-title]"));
  const sections = Array.from(document.querySelectorAll(".section"));

  const filter = () => {
    const query = input.value.trim().toLowerCase();
    let visibleCount = 0;

    items.forEach((item) => {
      const haystack = (item.dataset.title || "").toLowerCase();
      const match = query === "" || haystack.includes(query);
      item.classList.toggle("is-hidden", !match);
      if (match) visibleCount += 1;
    });

    // Hide a whole section when none of its items match.
    sections.forEach((section) => {
      const anyVisible = section.querySelector("[data-title]:not(.is-hidden)");
      section.classList.toggle("is-hidden", !anyVisible);
    });

    if (empty) empty.hidden = visibleCount !== 0;
  };

  input.addEventListener("input", filter);
}

document.addEventListener("DOMContentLoaded", () => {
  initMobileNav();
  initSearch();
});

// dev 1782641006736